<template>
    <div class="client-view" v-loading="loading">
        <div v-show="!showNext">
            <div v-if="menuList.length > 0">
                <div v-for="(menu, i) in menuList" :key="i" class="menu-item" @click="goToNext(menu)">
                    <div style="flex: 1;">{{ menu.title }}</div>
                    <SvgIcon style="align-self: center;" name="next" size="16"></SvgIcon>
                </div>
            </div>
            <el-empty v-else description="暂无数据"></el-empty>
        </div>
        <ClientView v-if="showNext" :menuTree="wholeTree"></ClientView>
    </div>
</template>

<script>
import SvgIcon from '../components/SvgIcon.vue'
import ClientView from './index'
export default {
    name: 'ClientView',
    props: {
        menuTree: {
            type: Array
        }
    },
    components: {
        ClientView,
        SvgIcon
    },
    watch: {
        '$route.query': function(newVal) {
            if (newVal.catalogId) {
                if (newVal.catalogId === this.catalogId) {
                    this.showNext = false
                } else {
                    this.showNext = true
                }
                
            } else {
                if (this.catalogId) {
                    this.showNext = true
                } else {
                    this.showNext = false
                }
            }
        }
    },
    data() {
        return {
            loading: true,
            wholeTree: [],
            menuList: [],
            catalogId: '',
            showNext: false
        }
    },
    methods: {
        goToNext(item) {
            if (item.type === 'page') {
                this.$http({
                    url: '/v1/content/itemById',
                    method: 'get',
                    params: {itemId: item.id}
                }).then(res => {
                    if (res.bodyType === 0) {
                        this.$router.push('/pageDetail?itemId=' + item.id)
                    } else {
                        window.location.href = res.body
                    }
                }).catch(err => {
                    console.info(err)
                })
            } else {
                if (this.wholeTree.length === 0) {
                    this.wholeTree = this.menuTree
                }
                this.$router.push({
                    path: '/clientView',
                    query: {
                        contentId: this.$route.query.contentId,
                        catalogId: item.id
                    }
                })  
            }
        },
        initData() {
            this.$http({
                method: 'get',
                url: '/v1/content/catalog',
                params: {
                    contentId: this.$route.query.contentId
                }
            }).then(res => {
                if (this.catalogId) {
                    const myCatalog = this.findMyCatalog(res)
                    if (myCatalog) {
                        this.menuList = myCatalog.children
                    }
                } else {
                    this.menuList = res
                }
                this.wholeTree = res
                this.loading = false
            }).catch(err => {
                this.loading = false
                console.info(err)
            })
        },
        findMyCatalog(dataList) {
            let nextData = []
            let myCatalog

            if (!dataList.length) {
                return myCatalog
            }
            for (let i = 0; i < dataList.length; i++) {
                if (dataList[i].id === this.catalogId) {
                    myCatalog = dataList[i]
                    break
                } else if(dataList[i].type === 'catalog') {
                    nextData = nextData.concat(dataList[i].children)
                }
            }

            if (!myCatalog) {
                myCatalog = this.findMyCatalog(nextData)
            }
            return myCatalog
        }
    },
    created() {
        if (this.$route.query.catalogId) {
            this.catalogId = this.$route.query.catalogId
        }

        if (this.menuTree && this.menuTree.length) {
            let myCatalog = this.findMyCatalog(this.menuTree)
            if (myCatalog) {
                this.menuList = myCatalog.children
            }
            this.loading = false
        } else {
            this.initData()
        }
    }
}
</script>

<style lang="scss">
.client-view {
    .menu-item {
        display: flex;
        line-height: 60px;
        font-size: 16px;
        color: #212121;
        padding: 0 16px;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/ClientView.vue